import { SH_BILLABLE_LINE_ITEM } from "../../models/sh-billable-line-item";

/**
 * Cancellation reason enumerations
 *
 * @type {Object}
 */
export const PROJECT_CANCELLATION__CANCELLATION_REASONS = {
  ACCESS_NOT_SECURED: 'access_not_secured',
  BAD_DELIVERABLES: 'bad_deliverables',
  PROJECT_NOT_RELEVANT: 'project_not_relevant',
  MARKED_ACTIVE_ACCIDENT: 'marked_active_accident',
  OTHER: 'other'
};

export function getProjectCancellationApplicationIncludes(user) {
  const includes = [
    'buyer.company',
    'buyer',
    'seller',
    'services',
    'project-line-items',
  ];

  const sellerIncludes = ['sh-payments'];
  const buyerIncludes = ['sh-invoices', 'sh-invoice-line-items', 'buyer.company.default-cost-code'];

  user.isSeller
    ? includes.push(...sellerIncludes)
    : includes.push(...buyerIncludes);

  return includes;
}

/**
 * Querey params for project cancellation
 *
 * @type {Object}
 */
export const PROJECT_CANCELLATION__QUERY_PARAMS = {
  PROJECT_CANCELLATION_REASON: 'projectCancellationReason',
  ADDITIONAL_INFORMATION_NOTES: 'additionalInformationNotes',
};

/**
 * The types of line items in the calculation of the base project price for a cancelled project for the seller
 *
 * @type {string[]}
 */
export const PROJECT_CANCELLATION__TYPES_IN_SELLER_PROJECT_PRICE = [
  SH_BILLABLE_LINE_ITEM.TYPES.BASE,
  SH_BILLABLE_LINE_ITEM.TYPES.CANCELLATION
];
